import React, { useContext, useState } from 'react';
import projectContext from '../../context/projects/projectContext';

const NewProject = () => {

    const projectsContext = useContext(projectContext);
    const { form, errorForm, showForm, addProject, showError } = projectsContext;

    const [project, setProject] = useState({
        name: ''
    });

    const { name } = project;

    const onChangeProject = (e) => {
        setProject({
            ...project,
            [e.target.name]: e.target.value
        })
    }

    const onSubmitProject = (e) => {
        e.preventDefault();
        
        // Validar proyecto
        if( name === ''){
            showError();
            return;
        }
        
        //Agregar al state
        addProject( project );

        //Reiniciar form
        setProject({
            name: ''
        });
    }

    const onClickForm = () => {
        showForm();
    }

    return ( 
        <>
            <button
                type="button"
                className="btn btn-block btn-primario"
                onClick={ onClickForm }
            >
                New Project
            </button>
            {
                form
                ? (
                    <form
                        className="formulario-nuevo-proyecto"
                        onSubmit={ onSubmitProject }
                    >
                        <input 
                            type="text"
                            className="input-text"
                            placeholder="Project Name"
                            name="name"
                            value={ name }
                            onChange={ onChangeProject }
                        />
                        <input 
                            type="submit"
                            className="btn btn-block btn-primario"
                            value="Add Project"
                        />
                    </form>
                )
                : null
            }
            {
                errorForm 
                    ? <p className="mensaje error">
                        Project's name is required
                      </p>
                    : null
            }
        </>
     );
}
 
export default NewProject;